import { injectIntl } from 'react-intl';
import DiscountEditReasonSelect from './DiscountEditReasonSelect';

export default injectIntl(DiscountEditReasonSelect);
